import triangle from "./Triangle.svg";
import magnifyLens from "./MagnifyingGlass.svg";

import { isTerminal } from "../../../../constants";

import { BackArrowButton } from "../../componentsTerminal/BackArrowButton/BackArrowButton";
import useComponentVisible from "../../../../hooks/useComponentVisible/useComponentVisible";
import { useCustomDebounce } from "../../../../hooks/UseCustomDebounce/UseCustomDebounce";

import { v4 as uuidv4 } from "uuid";
import { useSearchParams } from "react-router-dom";


import React, { memo, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { usePopper } from "react-popper";


isTerminal ? import("./DropdownMenuTerminal.scss") : import("./DropdownForRecruitment.scss");

const DropdownForRecruitment = (
    {
        styleName,
        label,
        listOfOptions,
        selectOptionClick,
        stateProperty,
        currentRequest,
        initialMenuMessage,
        isValidKey,
        optionsLoader,
        dropdownDescription,
        helper,
        showBackButton,
    },
) => {
    const dropdownRef = useRef();

    const [searchParams] = useSearchParams();
    const queryString = searchParams.get("id");

    const [isMenuActive, setIsMenuActive] = useState(false);
    const [selectedOption, setSelectedOption] = useState(
        initialMenuMessage ? initialMenuMessage : null,
    );
    const [magnifyLensShow, setMagnifyLensShow] = useState(true);
    const [searchInput, setSearchInput] = useState("");
    const [filteredArray, setFilteredArray] = useState( []);
    function searchInputHandler (event) {
        setSearchInput(event.target.value);
    }
    function handleSearch (value) {
        if (value.length) {
            const temp = listOfOptions.filter(element =>
                element.fullName.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredArray(temp);
        } else {
            setFilteredArray([]);
        }
    };
    const debouncedSearch = useCustomDebounce(handleSearch, 300);
    useEffect(() => {
        handleSearch(searchInput);
    }, [searchInput]);
    console.log(searchInput);
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const portalRef = useRef(null);
    const [
        ref,
        isComponentVisible,
        setIsComponentVisible,
        // forceClose,
    ] = useComponentVisible(false, { portalRef });
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        modifiers: {
            name: "offset",
            options: {
                offset: [0, 0],
            },
        },
        placement: "bottom-start",
    });
    console.log(styles);
    // function toggleMenuHandler(e) {
    //     setIsMenuActive(!isMenuActive);
    // }

    // function clickOutside(e) {
    //     if (!dropdownRef.current.contains(e.target)) {
    //         setIsMenuActive(false);
    //     }
    // }
    //
    // useEffect(() => {
    //     document.addEventListener("mousedown", clickOutside);
    //     return () => document.removeEventListener("mousedown", clickOutside);
    // }, []);

    return (
        <>
            <div className={`dropdown-${styleName}-container`}>
                <label
                    className={`dropdown-${styleName}__label`}
                    htmlFor={`${styleName}-selected`}>
                    {showBackButton && <BackArrowButton />}
                    {label}
                </label>
                <div
                    className={`dropdown-${styleName}`}

                    // ref={dropdownRef}
                >
                    {/*CONTAINER*/}
                    <div
                        ref={ref => {
                            setReferenceElement(ref);
                        }}
                        className={`dropdown-${styleName}__select-${isComponentVisible ? "active" : "hidden"}
                            ${isValidKey === false ? `dropdown-${styleName}__select-danger` : ""}`}
                        onClick={() => setIsComponentVisible(prev => !prev)}
                    >
                        <div className={`dropdown-${styleName}__select__selected`}>
                            {
                                currentRequest ||
                                currentRequest.uid === queryString
                                    ? listOfOptions &&
                                    listOfOptions.filter(e => e.pid === currentRequest[`${stateProperty}`]).length &&
                                    listOfOptions.find(e => e.pid === currentRequest[`${stateProperty}`]).fullName
                                        ? listOfOptions.find(e => e.pid === currentRequest[`${stateProperty}`]).fullName
                                        : ""

                                    : selectedOption
                            }
                            {/*{*/}
                            {/*    currentRequest*/}
                            {/*        ? listOfOptions &&*/}
                            {/*        listOfOptions.filter(e => e.pid === currentRequest[`${stateProperty}`]).length &&*/}
                            {/*        listOfOptions.find(e => e.pid === currentRequest[`${stateProperty}`]).fullName*/}
                            {/*            ? listOfOptions.find(e => e.pid === currentRequest[`${stateProperty}`]).fullName*/}
                            {/*            :*/}
                            {/*            // ""*/}
                            {/*            ( <div className={"application-filter__input"} >*/}
                            {/*                {magnifyLensShow && !searchInput && <img src={magnifyLens} alt="search" />}*/}
                            {/*                <input*/}
                            {/*                    // placeholder={"Поиск по ФИО"}*/}
                            {/*                    onChange={searchInputHandler}*/}
                            {/*                    value={searchInput ? searchInput :""}*/}
                            {/*                    // onFocus={() => setMagnifyLensShow(false)}*/}
                            {/*                    type="text"*/}
                            {/*                    onMouseUp={() => {*/}
                            {/*                        // setMagnifyLensShow(false);*/}
                            {/*                    }}*/}
                            {/*                    onMouseOut={() => {*/}
                            {/*                        // if (!searchInput.length) {*/}
                            {/*                        //     setMagnifyLensShow(true);*/}
                            {/*                        // } else {*/}
                            {/*                        //     setMagnifyLensShow(false);*/}
                            {/*                        // }*/}
                            {/*                    }}/>*/}
                            {/*            </div>)*/}
                            {/*        : selectedOption ? selectedOption :( <div className={"application-filter__input"} >*/}
                            {/*            {magnifyLensShow && !searchInput && <img src={magnifyLens} alt="search" />}*/}
                            {/*            <input*/}
                            {/*                onChange={searchInputHandler}*/}
                            {/*                value={searchInput ? searchInput :""}*/}
                            {/*                // onFocus={() => setMagnifyLensShow(false)}*/}
                            {/*                type="text"*/}
                            {/*                onMouseUp={() => {*/}
                            {/*                    // setMagnifyLensShow(false);*/}
                            {/*                }}*/}
                            {/*                onMouseOut={() => {*/}
                            {/*                    // if (!searchInput.length) {*/}
                            {/*                    //     setMagnifyLensShow(true);*/}
                            {/*                    // } else {*/}
                            {/*                    //     setMagnifyLensShow(false);*/}
                            {/*                    // }*/}
                            {/*                }}/>*/}
                            {/*        </div>)*/}
                            {/*        // selectedOption*/}
                            {/*}*/}

                        </div>
                        <div className={`dropdown-${styleName}__select__arrow`}>
                            <img
                                className={`dropdown-${styleName}__select__arrow-${isComponentVisible ? "up" : "down"}`}
                                src={triangle}
                                alt="arrow" />
                        </div>
                    </div>
                    {/*DROPDOWN*/}
                    {
                        isComponentVisible
                        && createPortal(
                            <div
                                ref={setPopperElement}
                                style={{...styles.popper, zIndex: 100}}
                                {...attributes.popper}
                            >
                                {optionsLoader
                                    ? <ul ref={portalRef} className={`dropdown-${styleName}__options-${isComponentVisible ? "active" : "hidden"}`}>
                                        <li className={`dropdown-${styleName}__empty-item`}></li>
                                        <li className={`dropdown-${styleName}__empty-item`}></li>
                                        <li className={`dropdown-${styleName}__empty-item`}></li>
                                        <li className={`dropdown-${styleName}__empty-item`}></li>
                                    </ul>
                                    // :<div ref={portalRef}  className={`dropdown-${styleName}__options-${isComponentVisible ? "active" : "hidden"}`}>
                                        :<div ref={portalRef}  className={`dropdown-${styleName}__options-active`}>

                                    <div className={"application-filter__input"} >
                                            {magnifyLensShow && !searchInput && <img src={magnifyLens} alt="search" />}
                                            <input
                                                // placeholder={"Поиск по ФИО"}
                                                onChange={searchInputHandler}
                                                value={searchInput ? searchInput :""}
                                                onFocus={() => setMagnifyLensShow(false)}
                                                type="text"
                                                onMouseUp={() => {
                                                    setMagnifyLensShow(false);
                                                }}
                                                onMouseOut={() => {
                                                    if (!searchInput.length) {
                                                        setMagnifyLensShow(true);
                                                    } else {
                                                        setMagnifyLensShow(false);
                                                    }
                                                }}/>
                                        </div>
                                        <ul className={`dropdown-${styleName}__options-${ isComponentVisible  ? "active" : "hidden"}`}>
                                            {!searchInput ?
                                                  listOfOptions &&  listOfOptions.map(element => {
                                                    return (
                                                        // DROPDOWN ITEM
                                                        <li
                                                            key={uuidv4()}
                                                            id={element.id ? `${element.id}` : ""}
                                                            className={`dropdown-${styleName}__item`}
                                                            onClick={(event) => {
                                                                setSelectedOption(element.fullName);
                                                                setIsComponentVisible(false);
                                                                setSearchInput("");
                                                                selectOptionClick && selectOptionClick(event, element, stateProperty);
                                                            }}>
                                                            <div className={`dropdown-${styleName}__item__text employe-name`}>
                                                                {element.fullName}
                                                            </div>
                                                            <div className={`dropdown-${styleName}__item__text`}>
                                                                {element.jobTitle}
                                                            </div>
                                                            <div className={`dropdown-${styleName}__item__text`}>
                                                                {element.fullStructName}
                                                            </div>
                                                            <div className={`dropdown-${styleName}__item__text`}>
                                                                Табельный № {element.tabNumber}
                                                            </div>
                                                        </li>
                                                    );
                                                })
                                                :
                                                  filteredArray &&  filteredArray.map(element => {
                                                    return (
                                                        // DROPDOWN ITEM
                                                        <li
                                                            key={uuidv4()}
                                                            id={element.id ? `${element.id}` : ""}
                                                            className={`dropdown-${styleName}__item`}
                                                            onClick={(event) => {
                                                                setSelectedOption(element.fullName);
                                                                setIsComponentVisible(false);
                                                                setSearchInput("");
                                                                selectOptionClick && selectOptionClick(event, element, stateProperty);
                                                            }}>
                                                            <div className={`dropdown-${styleName}__item__text employe-name`}>
                                                                {element.fullName}
                                                            </div>
                                                            <div className={`dropdown-${styleName}__item__text`}>
                                                                {element.jobTitle}
                                                            </div>
                                                            <div className={`dropdown-${styleName}__item__text`}>
                                                                {element.fullStructName}
                                                            </div>
                                                            <div className={`dropdown-${styleName}__item__text`}>
                                                                Табельный № {element.tabNumber}
                                                            </div>
                                                        </li>
                                                    );
                                                })
                                            }
                                        </ul>
                                    </div>
                                }
                            </div>,
                            document.querySelector("#popup"))
                    }

                </div>
                {
                    dropdownDescription
                        ? (
                            <div className={`dropdown-${styleName}__description`}>
                                {dropdownDescription}
                            </div>
                        )
                        : null
                }
                {/*typeof isValidKey !== 'undefined'*/}
                {isValidKey === false
                    ? <div className={`dropdown-${styleName}__item__underline`}>
                        Обязательное поле
                    </div>
                    : null
                }
                {
                    helper &&
                    (
                        <p
                            className={`dropdown-${styleName}-comment__underline`}>
                            {helper}
                        </p>
                    )
                }
            </div>
        </>

    );
};

export default memo(DropdownForRecruitment);
